import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineAsyncComponent } from 'vue';
import Feature from 'Services/Feature';


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'ListingSwitch',
  setup(__props) {



const Listing = Feature.isEnabled('new-listing-ui')
    ? defineAsyncComponent(() => import('vcomponents/listing/Listing.vue'))
    : defineAsyncComponent(() => import('vcomponents/listing/legacy/Listing.vue'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(Listing)), _normalizeProps(_guardReactiveProps(_ctx.$attrs as any)), {
    header: _withCtx(() => [
      _renderSlot(_ctx.$slots, "header")
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */))
}
}

})